const AnalyticsEventEnum = Object.freeze({
  TRANSACTION_STEP_ONE: {
    event: 'transaction_step_one',
    activityClass: 'TrxCalculatorActivity',
    label: 'Transaction Step One'
  },
  TRANSACTION_STEP_LTF: {
    event: 'transaction_step_ltf',
    activityClass: 'TrxLtfFormActivity',
    label: 'LTF Form Step'
  },
  TRANSACTION_BENEFICIARY_STEP: {
    event: 'transaction_beneficiary_step',
    activityClass: 'TrxBeneficiaryActivity',
    label: 'Transaction Beneficiary Step'
  },
  TRANSACTION_PAYMENT_STEP: {
    event: 'transaction_payment_step',
    activityClass: 'TrxPaymentActivity',
    label: 'Transaction Payment Step'
  },
  CONFIRMATION_PAYMENT_NOT_AUTHORISED: {
    event: 'confirmation_payment_not_authorised',
    activityClass: 'TrxPaymentNotAuthorisedActivity',
    label: 'Confirmation Payment Not Authorised'
  },
  CONFIRMATION_PAYMENT_AUTHORISED: {
    event: 'confirmation_payment_authorised',
    activityClass: 'TrxPaymentAuthorisedActivity',
    label: 'Confirmation Payment Authorised'
  },
  CONFIRMATION_PAYMENT_DEFERRED: {
    event: 'confirmation_payment_deferred',
    activityClass: 'TrxPaymentDeferredActivity',
    label: 'Confirmation Payment Deferred'
  },
  RPI_STEP_ONE: {
    event: 'rpi_step_one',
    activityClass: 'RpiCalculatorActivity',
    label: 'RPI Step One'
  },
  RPI_BENEFICIARY_STEP: {
    event: 'rpi_beneficiary_step',
    activityClass: 'RpiBeneficiaryActivity',
    label: 'RPI Beneficiary Step'
  },
  RPI_PAYMENT_SELECTION: {
    event: 'rpi_payment_selection',
    activityClass: 'RpiPaymentActivity',
    label: 'RPI Payment Selection'
  },
  RPI_SETUP_CONFIRMATION: {
    event: 'rpi_setup_confirmation',
    activityClass: 'RpiSetupActivity',
    label: 'RPI Setup Confirmation'
  },
  CLICK_MAKE_NEW_TRANSFER: {
    event: 'click_make_new_transfer',
    activityClass: 'CalculatorMakeTransfer',
    label: 'Click Make New Transfer'
  }
})

export default AnalyticsEventEnum
